function NotFound(){
    return(
        <div>
            <h1>404 Error</h1>
            <a href="../">Let's Go back to Homepage</a>
        </div>
    )
}
export default NotFound